import { Footer } from 'antd/lib/layout/layout'
import React from 'react'

const FooterComponent = () => {
    return (
        <Footer className='footer'>
            <p style={{ color: '#FFF' }}>Tech Dairy &copy; 2021 </p>
        </Footer>
    )
}

export default FooterComponent
